<div class="At-SettingsContent">
  <div class="At-InformationBox">
    <div class="At-Title">
      <h3>Language</h3>
    </div>
    <ul class="At-InformationList">
      <li>
        <div class="At-InfoBox">
            <label class="At-checkBoxLabel">
              <input type="radio" name="language" checked="checked">
              <span class="checkmark"></span>
              <span class="checktext">English</span>
            </label>
        </div>
      </li>
      <li>
        <div class="At-InfoBox">
          <label class="At-checkBoxLabel">
            <input type="radio" name="language">
            <span class="checkmark"></span>
            <span class="checktext">Indonesian</span>
          </label>
        </div>
      </li>
    </ul>
  </div>
